let wavPageUrl;
let wavArAssets;
let wavProductVariants;
let wavBlockId;

document.addEventListener('DOMContentLoaded', function(){

  // Add flexslider control to bring Frame render to attention
  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('single-option-selector')) {
      $('.product_slider').flexslider(0);
    }
  });

  

  const productsJsonElement = document.getElementById('wavar-product-json');
  const data = JSON.parse(productsJsonElement.textContent);

  wavPageUrl = data.pageUrl;
  wavArAssets = data.cmArAssets;
  wavProductVariants = data.cmProductVariants;
  wavBlockId = data.cmBlockId;

  function wavUsePushState(handler){

    //modern themes use pushstate to track variant changes without reload
    function track (fn, handler, before) {
      return function interceptor () {
        if (before) {
          handler.apply(this, arguments);
          return fn.apply(this, arguments);
        } else {
          const result = fn.apply(this, arguments);
          handler.apply(this, arguments);
          return result;
        }
      };
    }

    let currentVariantId = null;

    function wavVariantHandler () {
      const selectedVariantId = window.location.search.replace(/.*variant=(\d+).*/, '$1');
      //console.log('checking variant change to '+ selectedVariantId);
      if(!selectedVariantId) return;
      if(selectedVariantId !== currentVariantId){
        currentVariantId = selectedVariantId;
        handler(selectedVariantId);
      }
    }

    // Assign listeners
    window.history.pushState = track(history.pushState, wavVariantHandler);
    window.history.replaceState = track(history.replaceState, wavVariantHandler);
    window.addEventListener('popstate', wavVariantHandler);
  }

  wavUsePushState(function(variantId){
    // console.log(`variant: ${variantId} selected`);
    wavUpdateVariantArAsset(variantId);
    // publishCustomEvent(variantId);
  });

});

const wavUpdateVariantArAsset = function (variantId) {
  const selectedAsset = wavArAssets.filter(obj => obj.id == `gid://shopify/ProductVariant/${variantId}`);
  const selectedVariant = wavProductVariants.filter(obj => obj.id == variantId);

  // Update AR view
  const cmSceneVieer = document.getElementById(`cmActivateSceneViewer-${wavBlockId}`);
  const cmQuickLook = document.getElementById(`cmActivateQuickLook-${wavBlockId}`);
  cmSceneVieer.setAttribute('href', `intent://arvr.google.com/scene-viewer/1.1?file=${ selectedAsset[0].glb_link }&disable_occlusion=true&mode=ar_preferred&enable_vertical_placement=true&link=${wavPageUrl}?variant=${variantId}&title=${ selectedVariant[0].title }#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${wavPageUrl};end;`);
  cmQuickLook.setAttribute('data-href', `${ selectedAsset[0].usdz_link }#canonicalWebPageURL=${wavPageUrl}?variant=${variantId}`);
  
  // Update QR Code for product page
  if (document.querySelector(".cm-qr-code").childElementCount !== 0) {
      document.querySelector(".cm-qr-code").innerHTML = "";
  }
  new QRCode(document.querySelector(".cm-qr-code"), {
      text: `${wavPageUrl}?variant=${variantId}`,
      width: 180, //default 128
      height: 180,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
  });
  
  // Temporary fix code for Frames render
  // $('.product_slider').flexslider(0);

  // const wavRender = document.querySelector("#wavar-frames-render .wav-frame");

  // if (!wavRender) return;

  // html2canvas(wavRender).then(function(canvas) {
  //   canvas.toBlob((blob) => {
  //     const renderThumb = document.querySelector(".product_slider .flex-control-nav.flex-control-thumbs li img");
  //     const url = URL.createObjectURL(blob);
    
  //     renderThumb.src = url;
  //   });
  // });
  

}